import { useEffect } from 'react';
import useResizeObserver from 'use-resize-observer';
var useMeasureCarouselHeight = function (ref) {
    var height = useResizeObserver({ ref: ref }).height;
    useEffect(function () {
        var resizeObserverError = function (event) {
            if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        };
        window.addEventListener('error', resizeObserverError);
        return function () {
            window.removeEventListener('error', resizeObserverError);
        };
    }, []);
    return height;
};
export default useMeasureCarouselHeight;
